import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #d8d8d8;
`;
